let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4zv97")).then(() => parcelRequire('kWIk8'));